import React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import ArrowRight from '@mui/icons-material/ArrowRight';
import BulkConfigStep from '../ui/bulk-config-step';
import { Properties } from '../types';

export interface ISelectPropertyProps {
  properties: Properties;
  selectedPropertyId: string;
  error?: string;
  onSelectProperty: (propertyId: string) => void;
  onNext: () => void;
}

// Initial step to select a property to bulk configure
export default function SelectProperty({
  properties,
  selectedPropertyId,
  error,
  onSelectProperty,
  onNext,
}: ISelectPropertyProps) {
  const bottomActions = [
    { name: 'Next', action: onNext, endIcon: <ArrowRight /> },
  ];

  // Sort properties alphabetically by title
  const sortedProperties = [...properties].sort((a, b) =>
    a.title.localeCompare(b.title),
  );

  return (
    <BulkConfigStep
      title="Step 1: Select Property"
      bottomActions={bottomActions}
      topActions={[]}
      error={error}
    >
      <FormControl style={{ padding: '0', width: '100%' }}>
        <RadioGroup
          value={selectedPropertyId}
          onChange={(_, v) => onSelectProperty(v)}
        >
          {sortedProperties.map((p: Properties[number]) => {
            return (
              <FormControlLabel
                key={p._id}
                value={p._id}
                control={<Radio color="secondary" size="small" />}
                label={p.title + ', ' + p.address.line1}
                className="form-control-label"
                sx={{ marginLeft: 0, marginRight: 0 }}
              />
            );
          })}
        </RadioGroup>
      </FormControl>
    </BulkConfigStep>
  );
}
